/* Avise-me quando voltar (snippets/back-in-stock.liquid). Um arquivo, defer, sem
   dependencia, carregado so quando o bloco existe na pagina.

   O que faz
   1. Descobre a chave publica do Klaviyo: a do setting do tema (data-bis-key) ou, vazio,
      o company_id do script do app embed do Klaviyo na pagina. Sem nenhuma das duas, o
      bloco continua hidden e nada mais acontece: a pagina nunca mostra um formulario que
      nao funciona.
   2. Cria o <form> do aviso FORA do formulario de produto (o campo e o botao apontam
      para ele pelo atributo form), para nao haver form dentro de form.
   3. Segue a variante escolhida: le o campo name="id" do formulario de produto a cada
      change (o change do radio ou do select chega aqui depois do script da secao ja ter
      trocado o id) e mostra o bloco so quando a variante esta esgotada.
   4. Na camiseta (data-bis-unlock), libera as opcoes de tamanho esgotado do <select>:
      sem isso nao da para escolher o tamanho e pedir aviso. O script da propria secao
      ja desliga o botao de compra pelo data-available da opcao.
   5. Envia com fetch para o Klaviyo e mostra sucesso ou erro com os textos do editor.

   Contrato do Klaviyo, conferido em 01/10/2026 na referencia "Create Client Back In
   Stock Subscription" (https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription):
   POST, chave publica na query, sem Authorization, corpo JSON:API, sucesso 202 sem
   corpo. Erro 4xx no formato { errors: [{ status, code, detail, source: { pointer } }] };
   e-mail invalido volta 400 com pointer /data/attributes/profile/data/attributes/email.
   O id da variante no catalogo da integracao Shopify e $shopify:::$default:::ID
   (guia "How to set up custom back in stock"). */
(() => {
  'use strict';

  const ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions';
  const REVISION = '2026-07-15';
  const VARIANT_PREFIX = '$shopify:::$default:::';
  const KEY = /^[A-Za-z0-9]{6}$/;
  const TIMEOUT = 15000;

  /* variantes ja inscritas nesta visita: voltar a um tamanho ja pedido mostra a confirmacao */
  const subscribed = new Set();

  const companyId = block => {
    const own = (block.dataset.bisKey || '').trim();
    if (KEY.test(own)) return own;
    const tag = document.querySelector('script[src*="klaviyo.com/onsite/js/"]');
    if (!tag) return '';
    try {
      const url = new URL(tag.getAttribute('src'), window.location.href);
      const query = url.searchParams.get('company_id') || '';
      if (KEY.test(query)) return query;
      const path = url.pathname.match(/\/onsite\/js\/([A-Za-z0-9]{6})\//);
      if (path) return path[1];
    } catch (error) { /* src fora do formato: fica sem chave */ }
    return '';
  };

  const send = async (key, email, variantId) => {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = controller ? window.setTimeout(() => controller.abort(), TIMEOUT) : 0;
    try {
      const response = await fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/vnd.api+json',
          revision: REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: VARIANT_PREFIX + variantId } }
            }
          }
        }),
        signal: controller ? controller.signal : undefined
      });
      if (response.ok) return 'success';
      let errors = [];
      try { errors = (await response.json()).errors || []; } catch (error) { errors = []; }
      const badEmail = errors.some(item => /email/i.test(String((item && item.source && item.source.pointer) || '')));
      if (!badEmail) console.warn('Back in stock: Klaviyo answered ' + response.status, errors);
      return badEmail ? 'invalid' : 'error';
    } catch (error) {
      console.warn('Back in stock: request failed', error);
      return 'error';
    } finally {
      if (timer) window.clearTimeout(timer);
    }
  };

  function setup(block) {
    if (block.dataset.bisReady) return;
    const productForm = block.closest('form');
    const key = companyId(block);
    const input = block.querySelector('.bis__input');
    const button = block.querySelector('.bis__submit');
    const fields = block.querySelector('[data-bis-fields]');
    const status = block.querySelector('[data-bis-status]');
    const formId = block.dataset.bisFormId;
    if (!productForm || !key || !formId || !input || !button || !fields || !status || typeof window.fetch !== 'function') return;
    block.dataset.bisReady = 'true';

    let soldMap = {};
    try { soldMap = JSON.parse(block.querySelector('[data-bis-variants]').textContent) || {}; } catch (error) { soldMap = {}; }

    /* O form do aviso mora no fim do body. Recarregar a secao no editor cria outro com o
       mesmo id: o antigo sai, porque o listener dele aponta para o bloco que ja saiu. */
    const old = document.getElementById(formId);
    if (old) old.remove();
    const form = document.createElement('form');
    form.id = formId;
    form.hidden = true;
    form.noValidate = true;
    document.body.append(form);

    if (block.hasAttribute('data-bis-unlock')) {
      productForm.querySelectorAll('select[name="id"] option[disabled]').forEach(option => { option.disabled = false; });
    }

    status.tabIndex = -1;
    const say = (text, state) => {
      status.textContent = text || '';
      if (text && state) status.dataset.state = state;
      else delete status.dataset.state;
    };
    const currentId = () => {
      const field = productForm.querySelector('[name="id"]');
      return field ? String(field.value || '') : '';
    };

    let shownFor = '';
    const sync = () => {
      const id = currentId();
      const soldOut = id !== '' && soldMap[id] === false;
      block.hidden = !soldOut;
      if (!soldOut || id === shownFor) return;
      shownFor = id;
      input.removeAttribute('aria-invalid');
      if (subscribed.has(id)) {
        fields.hidden = true;
        say(block.dataset.success, 'success');
      } else {
        fields.hidden = false;
        say('', null);
      }
    };

    let busy = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const id = currentId();
      if (!id || soldMap[id] !== false) return;

      input.value = input.value.trim();
      if (!input.value || !input.checkValidity()) {
        input.setAttribute('aria-invalid', 'true');
        say(block.dataset.invalid, 'error');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');

      busy = true;
      button.disabled = true;
      block.setAttribute('aria-busy', 'true');
      say('', null);
      const outcome = await send(key, input.value, id);
      busy = false;
      button.disabled = false;
      block.removeAttribute('aria-busy');

      if (outcome === 'success') {
        subscribed.add(id);
        fields.hidden = true;
        say(block.dataset.success, 'success');
        status.focus();
        return;
      }
      if (outcome === 'invalid') {
        input.setAttribute('aria-invalid', 'true');
        say(block.dataset.invalid, 'error');
      } else {
        say(block.dataset.error, 'error');
      }
      input.focus();
    });

    input.addEventListener('input', () => {
      if (input.hasAttribute('aria-invalid')) {
        input.removeAttribute('aria-invalid');
        say('', null);
      }
    });

    productForm.addEventListener('change', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('[data-bis]').forEach(setup);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
